


export const FooterButton = (() => {
	var obj = {};
	obj.HOME = 'home';
	obj.WORKSHOPS = 'workshops';
	obj.WEBINARS = 'webinars';
	obj.DISCUSSIONS = 'discussions';
	obj.PUBLICATIONS = 'publications';
	obj.CLIPS = 'clips';

	return obj;
})();
